import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UserService } from 'src/app/features/requets/shared/user.service';
import { Employee } from 'src/app/features/requets/shared/model/employee.model';

@Component({
  selector: 'app-select-evaluator-dialog',
  templateUrl: './select-evaluator-dialog.component.html',
  styleUrls: ['./select-evaluator-dialog.component.scss']
})
export class SelectEvaluatorDialogComponent implements OnInit {

  displayedColumns: string[] = ['codigo', 'nombre'];
  dataSource: MatTableDataSource<Employee>;
  selectedRowIndex = -1;
  SelectItem: Employee;
  selected = 'DOCEN';
  expandedPanel = true;
  enabledSpinner = false;
  cedula: String;
  nombre: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SelectEvaluatorDialogComponent>,
              private userService: UserService) { }

  ngOnInit() {
    // this.dataSource.paginator = this.paginator;
   // this.dataSource.sort = this.sort;
  }

  close() {
    this.dialogRef.close(null);
  }

  findEvaluator() {
    const cedulaParam = !this.cedula ? null : this.cedula;
    const nombreParam = !this.nombre ? null : escape(this.nombre);
    this.enabledSpinner = true;
    this.userService.getEmployees(cedulaParam, nombreParam, this.selected).subscribe(
      (result) => {
        if (result.data) {
          this.dataSource = new MatTableDataSource(result.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.expandedPanel = false;
          this.enabledSpinner = false;
        }
      }
    );
  }

highlight(row) {
    this.selectedRowIndex = row.numeroIdentificacion;
    this.SelectItem =  row;
 }

 sendSelect() {
  const data = { index: this.data.index , item: this.SelectItem };
  this.dialogRef.close(data);
 }

}
